// The client side of /api/sales-assist: the AI behind the reps. Every
// call carries the signed-in session; the server only answers for the
// Testing Store's owner. Results are suggestions a rep confirms.
export async function assist(client, storeId, action, payload = {}) {
  const { data } = await client.auth.getSession();
  const token = data?.session?.access_token;
  if (!token) throw new Error('Your session expired. Reload and sign in again.');
  const res = await fetch('/api/sales-assist', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ action, store_id: storeId, ...payload }),
  });
  let body = null;
  try { body = await res.json(); } catch { /* fall through */ }
  if (!res.ok || !body?.success) throw new Error(body?.error || `The assistant did not answer (${res.status})`);
  return body;
}

/** The fields the brief needs from a prospect row. */
export const prospectForAssist = (p) => ({
  name: p.name, owner_name: p.owner_name, city: p.city, state: p.state, address: p.address, phone: p.phone, website: p.website, social: p.social, notes: p.notes, stage: p.stage,
});

/** Does the browser offer dictation (Web Speech)? */
export const speechSupported = () => typeof window !== 'undefined' && !!(window.SpeechRecognition || window.webkitSpeechRecognition);

/**
 * Start dictation. onText(fullTextSoFar, isFinal) fires as words arrive.
 * Returns a stop() function. Chrome and Safari; Firefox has none.
 */
export function startDictation(onText, onEnd) {
  const Ctor = window.SpeechRecognition || window.webkitSpeechRecognition;
  if (!Ctor) return () => {};
  const rec = new Ctor();
  rec.lang = 'en-US';
  rec.continuous = true;
  rec.interimResults = true;
  let finalText = '';
  rec.onresult = (e) => {
    let interim = '';
    for (let i = e.resultIndex; i < e.results.length; i++) {
      const r = e.results[i];
      if (r.isFinal) finalText += (finalText ? ' ' : '') + r[0].transcript.trim();
      else interim += r[0].transcript;
    }
    onText((finalText + (interim ? ` ${interim}` : '')).trim(), !interim);
  };
  rec.onerror = (e) => { console.warn('dictation', e.error); onEnd?.(e.error); };
  rec.onend = () => onEnd?.();
  try { rec.start(); } catch (e) { onEnd?.(String(e)); }
  return () => { try { rec.stop(); } catch { /* ignore */ } };
}
